import './auth.css';
import React, { Component } from 'react';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { login, signup, initForm } from './authActions';
import Row from '../common/layout/row';
import If from '../common/operator/if';
import Messages from '../common/msg/messages';
import Input from '../common/form/inputAuth';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import { ThemeProvider } from '@material-ui/styles';
import imagemLogo from '../assets/images/sologobranca.png';
import imagemFundo from '../assets/images/praia_mar_fundo.jpg';
import DateFormat from '../common/dateFormat/DateFormat';
import Grid from '../common/layout/grid';

class Auth extends Component {
	constructor(props) {
		super(props);
		this.state = { modo: 'login' };

		this.props.initForm({
			socio: true
		});
	}

	getStyles() {
		return makeStyles((theme) => ({
			paper: {
				marginTop: theme.spacing(8),
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center'
			},
			avatar: {
				margin: theme.spacing(1),
				backgroundColor: theme.palette.secondary.main
			},
			form: {
				width: '100%',
				marginTop: theme.spacing(1),
			},
			submit: {
				margin: theme.spacing(3, 0, 2),
			},
		}));
	}

	getTheme() {

		return createMuiTheme({
			palette: {
				primary: {
					// light: será calculada com base em palette.primary.main,
					main: '#FFCC00',
					// dark: será calculada com base em palette.primary.main,
					// contrastText: será calculada para contrastar com palette.primary.main
				},
				secondary: {
					light: '#8045FC',
					main: '#FFCC00',
					// dark: será calculada com base palette.secondary.main,
					contrastText: '#0042E2',
				},
				// Usado por `getContrastText()` para maximizar o contraste entre
				// o plano de fundo e o texto.
				contrastThreshold: 3,
				// Usado pelas funções abaixo para mudança de uma cor de luminância por aproximadamente
				// dois índices dentro de sua paleta tonal.
				// Por exemplo, mude de Red 500 para Red 300 ou Red 700.
				tonalOffset: 0.2,
			},
		});
	}

	render() {

		const classes = this.getStyles();

		const { handleSubmit } = this.props;

		const mobile = window.innerWidth < 900;

		return (
			<ThemeProvider theme={this.getTheme()}>
				<div style={{ backgroundColor: '#5ec4bc', height: '100%' }}>
					<div style={{ display: 'flex', alignItems: 'center', height: '100vh', backgroundSize: 'cover', background: 'linear-gradient(to bottom, #379DE2, #19CCCC)' }}>
						{/* <Container component="main" maxWidth="xs" style={{ width: '100%' }}> */}
							<CssBaseline />

							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
									alignItems: 'center',
									width: '100%',
									height: '100%',
									// backgroundImage: `url(${imagemFundo})`,
									backgroundColor: `#0042E2`,
									backgroundSize: 'cover',
									backgroundRepeat: 'no-repeat',
									backgroundPosition: 'center'
								}}>

								<div 
									style={{
										width: mobile ? '100%' : '50%',
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'center'
									}}>

									<img src={imagemLogo} style={{ width: mobile ? 100 : 200, marginBottom: 10 }}/>

									<div className={classes.paper} 
										style={{ 
											padding: 20, 
											borderRadius: 10, 
											textAlign: 'center',
											minWidth: 350,
											maxWidth: 400,
											width: mobile ? '95%' : null
										}}>

										{this.state.modo == 'login' &&
										<form className={classes.form} noValidate onSubmit={handleSubmit(v => this.props.login(v))}>

											{this.props.formularioValues && 
											<Row>
												<Grid cols='6 6 6 6'>
													<Button
														fullWidth
														variant="contained"
														color={this.props.formularioValues.socio ? 'secondary' : 'success'}
														className={classes.submit}
														style={{ marginTop: 20 }}
														onClick={() => {
															this.props.initForm({
																...this.props.formularioValues,
																socio: true
															});
														}} >
														Sou Sócio
													</Button>
												</Grid>
												<Grid cols='6 6 6 6'>
													<Button
														fullWidth
														variant="contained"
														color={!this.props.formularioValues.socio ? 'secondary' : 'success'}
														className={classes.submit}
														style={{ marginTop: 20 }}
														onClick={() => {
															this.props.initForm({
																...this.props.formularioValues,
																socio: false
															});
														}} >
														Não Sou Sócio
													</Button>
												</Grid>
											</Row>}

											{(this.props.formularioValues && this.props.formularioValues.socio) &&
											<>
												<TextField
													variant="filled"
													margin="normal"
													required
													fullWidth
													id="numero_carteirinha"
													label="Número da Carteirinha"
													name="numero_carteirinha"
													autoFocus
													style={{
														background: '#ffffff',
														borderRadius: 5
													}}
													onChange={(e => {
														this.props.initForm({
															...this.props.formularioValues,
															numero_carteirinha: e.target.value
														});
													})} />

												<TextField
													variant="filled"
													margin="normal"
													required
													fullWidth
													id="cpf"
													label="CPF"
													name="cpf"
													style={{
														background: '#ffffff',
														borderRadius: 5
													}}
													onChange={(e => {
														this.props.initForm({
															...this.props.formularioValues,
															cpf: e.target.value
														});
													})} />

												<TextField
													variant="filled"
													margin="normal"
													required
													fullWidth
													name="senha"
													label="Senha"
													type="password"
													id="senha"
													autoComplete="current-password"
													style={{
														background: '#ffffff',
														borderRadius: 5
													}}
													onChange={(e => {
														this.props.initForm({
															...this.props.formularioValues,
															senha: e.target.value
														});
													})} />
											</>}

											<Button
												type="submit"
												fullWidth
												variant="contained"
												color="primary"
												className={classes.submit}
												style={{ marginTop: 20 }} >
												Entrar
											</Button>

											<p style={{ marginTop: 16, fontSize: 16, color: '#FFCC00' }}>Não tem uma conta? <a href='#' style={{ color: '#ffffff' }} 
												onClick={() => {
													this.setState({
														...this.state,
														modo: 'cadastro'
													});
													this.props.initForm({
														login: '',
														senha: '',
														datahora_aceite_politica_privacidade: null
													})
												}}>Cadastre-se</a></p>

										</form>}

										{this.state.modo == 'cadastro' &&
										<form className={classes.form} noValidate onSubmit={handleSubmit(v => this.props.signup(v))}>

											<TextField
												variant="filled"
												margin="normal"
												required
												fullWidth
												id="numero_carteirinha"
												label="Número da Carteirinha"
												name="numero_carteirinha"
												autoFocus
												style={{
													background: '#ffffff',
													borderRadius: 5
												}}
												onChange={(e => {
													this.props.initForm({
														...this.props.formularioValues,
														numero_carteirinha: e.target.value
													});
												})} />

											<TextField
												variant="filled"
												margin="normal"
												required
												fullWidth
												id="cpf"
												label="CPF"
												name="cpf"
												style={{
													background: '#ffffff',
													borderRadius: 5
												}}
												onChange={(e => {
													this.props.initForm({
														...this.props.formularioValues,
														cpf: e.target.value
													});
												})} />

											<TextField
												variant="filled"
												margin="normal"
												required
												fullWidth
												name="senha"
												label="Senha"
												type="password"
												id="senha"
												style={{
													background: '#ffffff',
													borderRadius: 5
												}}
												onChange={(e => {
													this.props.initForm({
														...this.props.formularioValues,
														senha: e.target.value
													});
												})} />
											
											<TextField
												variant="filled"
												margin="normal"
												required
												fullWidth
												name="senha_confirmacao"
												label="Confirme a Senha"
												type="password"
												id="senha_confirmacao"
												style={{
													background: '#ffffff',
													borderRadius: 5
												}}
												onChange={(e => {
													this.props.initForm({
														...this.props.formularioValues,
														senha_confirmacao: e.target.value
													});
												})} />

											<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems : 'center', marginTop: 8, marginBottom: 16  }}>
												<input type="checkbox" required style={{ marginRight: 4, width: 20, height: 20 }} 
													onChange={data => {
														this.props.initForm({
															...this.props.formularioValues,
															datahora_aceite_politica_privacidade: this.props.formularioValues.datahora_aceite_politica_privacidade ? null : DateFormat.getDataHoraAtual()
														});
													}}/>
												<div style={{ fontWeight: 'bold', color: '#FFCC00' }}>Eu li e aceito a <a class='btn-politica' href='https://www.vivahospedagens.com.br/regulamentos' target='_blank'>Política e Regulamento</a></div>
											</div>

											<Button
												type="submit"
												fullWidth
												variant="contained"
												color="primary"
												disabled={!this.props.formularioValues.datahora_aceite_politica_privacidade}
												className={classes.submit} >
												Cadastrar
											</Button>

											<Button
												fullWidth
												variant="outlined"
												color="primary"
												className={classes.submit}
												style={{ marginTop: 8 }}
												onClick={() => {
													this.setState({
														...this.state,
														modo: 'login'
													});
													this.props.initForm({
														login: '',
														senha: ''
													})
												}} >
												Voltar para Login
											</Button>
										</form>}

									</div>
								</div>
								<Snackbar
									open={this.props.message.open}>
									<MuiAlert severity={this.props.message.type} variant="filled">
										{this.props.message.text}
									</MuiAlert>
								</Snackbar>
							{/* </Container> */}
						</div>
					</div>
				</div>
			</ThemeProvider>
		);
	}
}

Auth = reduxForm({form: 'authForm'})(Auth);
const mapStateToProps = state => ({
	message: state.auth.message,
	formularioValues: getFormValues('authForm')(state)
});
const mapDispatchToProps = dispatch => bindActionCreators({ login, signup, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Auth);
